import {
  ChartFrequency,
  IComposableChartsWidget,
  IPostgreJobsAnalyticsPayload,
} from 'wisestep-api';

import {
  CvUploadBarChartPostgre,
  CvUploadMetricChartPostgre,
  CvUploadTablePostgre,
} from '../../../../composableAnalytics/BaseCharts';
import { ChartScope } from '../../../types';
import { CvUploadWidget, getChartFreqForTimePeriod } from '../../helper';
import { jobsTimePeriodList } from '../../Jobs/helper';

const getCvUploadChartWidgetByTimeAndScope = (
  timePeriodId: string,
  scope: ChartScope,
  frequency: ChartFrequency = getChartFreqForTimePeriod[timePeriodId]
): Record<CvUploadWidget, IComposableChartsWidget> => {
  const defaultQuery: IPostgreJobsAnalyticsPayload = {
    category: 'cvupload',
    filters: [],
    type: 'total-metric',
    range: timePeriodId,
    scope,
    frequency,
  };
  const freqInRegularCase = frequency.charAt(0).toUpperCase() + frequency.slice(1).toLowerCase();

  const widgetConfig = {
    [CvUploadWidget.METRIC_TOTAL]: {
      name: 'Total CVs Uploaded',
      filters: {},
      category: 'cvupload',
      type: `metric_cvupload_${timePeriodId}_${scope}_postgre`,
      component: (
        <CvUploadMetricChartPostgre
          query={{ ...defaultQuery, type: 'total-metric' }}
          title="Total CVs Uploaded"
          widgetName={CvUploadWidget.METRIC_TOTAL}
        />
      ),
    },
    [CvUploadWidget.TABLE_RECRUITER]: {
      name: 'Total CVs Uploaded by Recruiters',
      filters: {},
      category: 'cvupload',
      type: `table_cvupload_${timePeriodId}_${scope}_postgre`,
      component: (
        <CvUploadTablePostgre
          query={{ ...defaultQuery, type: 'recruiter-table' }}
          title="Total CVs Uploaded by Recruiters"
          widgetName={CvUploadWidget.TABLE_RECRUITER}
        />
      ),
    },
    [CvUploadWidget.BAR_CHART]: {
      name: `Total CVs Uploaded - ${freqInRegularCase}`,
      filters: {},
      category: 'cvupload',
      type: `barchart_cvupload_${timePeriodId}_${scope}_${frequency}_postgre`,
      component: (
        <CvUploadBarChartPostgre
          query={{ ...defaultQuery, type: 'bar-chart' }}
          title={`Total CVs Uploaded ${freqInRegularCase}`}
          widgetName={CvUploadWidget.BAR_CHART}
        />
      ),
    },
  };

  return widgetConfig;
};

export const cvUploadChartsKeyPostgre = (
  timePeriodId: string,
  scope: ChartScope
): IComposableChartsWidget[] => {
  const defaultWidgetList = Object.values(
    getCvUploadChartWidgetByTimeAndScope(timePeriodId, scope)
  );
  const extraWidgetList = {};

  return [...defaultWidgetList, ...(extraWidgetList[timePeriodId] ?? [])];
};

export const postgreCvUploadDashboardKeysList = jobsTimePeriodList.flatMap((timePeriod) => [
  ...cvUploadChartsKeyPostgre(timePeriod.id, ChartScope.WORKSPACE),
  ...cvUploadChartsKeyPostgre(timePeriod.id, ChartScope.LOGGED_IN_USER),
]);
